<template>
    <el-dialog 
        title="商品详情" 
        :visible.sync="visible"  
        :before-close="handleClose" 
        width="1250px" 
        top="5vh"
        @open="handleOpen"
    >
        <SalesGoodsDetail ref="salesGoodsDetailRef"/>
    </el-dialog>
</template>
<script>
import SalesGoodsDetail from './salesGoodsDetail.vue';
    export default {
        name: 'SalesGoodsDialog',
        components: {
            SalesGoodsDetail
        },
        data() {
            return {
                visible:false,

            }
        },
        methods: {
            handleClose() {
                this.visible = false
            },
            publicOpen(){
                this.visible = true
            },
            handleOpen() {
                this.$nextTick(() => {
                    this.$refs.salesGoodsDetailRef.publicRequest()
                })
            }
        }
    }
</script>
<style scoped lang="scss">
</style>